import BasicGallery from './BasicGallery';
import $ from '../common/nano';

class FullScreenGallery {
	private isVisible: boolean = false;

	private galleryApi: BasicGallery = null;

	constructor() {
		this.initEvents();
	}

	private createGallery(): BasicGallery {
		return new BasicGallery(
			'.fullscreen-swiper',
			{
				grabCursor: false,
				freeMode: false
			}
		);
	}

	private initEvents() {
		$('.fullscreen-swiper-close').on('click', () => {
			this.hideFullScreen();
		});
	}

	showFullScreen() {
		$('body, html').addClass('full-screen-gallery no-scroll');
		this.isVisible = true;

		history.pushState(
			{
				'isGalleryOpen': true
			},
			null,
			'#gallery'
		);

		//todo ez elég szar megoldás
		window.onpopstate = () => {
			console.log('pop')
			if (this.isVisible) {
				this.hideFullScreen();
			}
		};
	}

	hideFullScreen() {
		$('body, html').removeClass('full-screen-gallery no-scroll');
		this.isVisible = false;

		if (history.state && history.state.isGalleryOpen) {
			history.back();
		}
	}

	getGalleryApi(): BasicGallery {
		if (!this.galleryApi) {
			this.galleryApi = this.createGallery();
		}

		return this.galleryApi;
	}

}

export default FullScreenGallery;